// Central conversion tracking for Meta Pixel + Google Ads.
// Meta events work out of the box (pixels are initialized in index.html).
// Google Ads conversions require the conversion LABELS from your Google Ads
// account (Goals → Conversions → Tag setup shows: AW-18340570662/LABEL).
// Paste the labels below to activate Google Ads conversion counting.
const GOOGLE_ADS_ID = 'AW-18340570662';
const GADS_PURCHASE_LABEL = ''; // TODO: paste Purchase/Sale conversion label
const GADS_LEAD_LABEL = '';     // TODO: paste Lead/Signup conversion label

const fbq = (...args) => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq(...args);
  }
};

const gtagConversion = (label, params = {}) => {
  if (!label) return; // no label configured yet — skip until provided
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', { send_to: `${GOOGLE_ADS_ID}/${label}`, ...params });
  }
};

// Fire on a successful payment (workshop / subscription).
export const trackPurchase = ({ value, currency = 'INR', transaction_id } = {}) => {
  fbq('track', 'Purchase', { value: Number(value) || 0, currency });
  gtagConversion(GADS_PURCHASE_LABEL, {
    value: Number(value) || 0,
    currency,
    ...(transaction_id ? { transaction_id } : {}),
  });
};

// Fire on a signup/registration (masterclass).
export const trackLead = ({ value, currency = 'INR' } = {}) => {
  fbq('track', 'Lead', value ? { value: Number(value), currency } : {});
  gtagConversion(GADS_LEAD_LABEL, value ? { value: Number(value), currency } : {});
};
